var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212221",
    fillRule: "evenodd",
    d: "M10.167 5.458H9.44V4.006A3.596 3.596 0 0 0 5.81.375a3.596 3.596 0 0 0-3.631 3.631v1.452h-.727C.654 5.458 0 6.112 0 6.911v7.262c0 .798.654 1.452 1.452 1.452h8.715c.799 0 1.452-.654 1.452-1.452V6.91c0-.8-.653-1.453-1.452-1.453M5.81 1.755a2.263 2.263 0 0 1 2.25 2.251v1.452H3.63V4.006h-.072A2.263 2.263 0 0 1 5.81 1.755m4.357 12.418H1.452V6.91h8.715zM5.81 11.994c.798 0 1.452-.653 1.452-1.452 0-.8-.654-1.453-1.452-1.453-.8 0-1.453.654-1.453 1.453s.654 1.452 1.453 1.452",
    clipRule: "evenodd"
  })));
};
export default SvgPadlock;